import { spacing } from './units';
const white = '#fff';
const black = '#111';

const palette = {
  common: {
    black,
    white,
  },
  primary: {
    main: '#292929',
    light: '#146DD6',
    contrastText: white,
    gradient: '',
  },
  secondary: {
    main: '#F1C086',
    light: '#146DD6',
    contrastText: '#141516',
    gradient: 'linear-gradient(116.68deg, rgb(241, 192, 134) -4.44%, rgb(199, 145, 100) 117.28%)',
  },
  white: {
    main: white,
    contrastText: '#141516',
  },
  grey: {
    DEFAULT: '#141516',
    800: '#141516',
    700: '#292929',
    600: '#3D3D3D',
    650: '#313131',
    500: '#525252',
    520: 'rgba(82, 82, 82, 0.2)',
    550: 'rgba(82, 82, 82, 0.5)',
    400: '#BABABA',
    300: '##DFDFDF',
    200: '#EEEEEE',
    100: '#F9F9F9',
  },
  gold: {
    DEFAULT: '#F1C086',
    900: '#51473C',
    200: 'rgba(241, 192, 134, 0.2)',
    700: 'rgba(241, 192, 134, 0.7)',
  },
  copper: '#C79164',
  brown: {
    DEFAULT: '#93694B',
  },
  blue: {
    DEFAULT: '#1C7FF2',
  },
  error: {
    main: '#E54949',
    contrastText: white,
  },
  danger: {
    main: '#E54949',
    contrastText: white,
  },
  success: {
    main: '#1FC090',
    contrastText: white,
  },
  table: {
    normal: [
      '#77CFAC',
      '#3A84DE',
      '#228C83',
      '#E88079',
      '#4040B5',
      '#EDE1D4',
      '#DEAB5E',
      '#C36B55',
      '#B54053',
      '#59BDC5',
      '#EED7B4',
    ],
    dark: [
      '#455F54',
      '#152D4B',
      '#0D302D',
      '#532D2B',
      '#1E1E59',
      '#5F5850',
      '#726046',
      '#5E3731',
      '#653E45',
      '#2A4E51',
      '#453F36',
    ],
  },
};

const shadows = {
  0: 'none',
  regular: '0px 0px 12px rgba(20, 21, 22, 0.12)',
  large: '0px 0px 40px rgba(0, 0, 0, 0.2)',
};

const bordedRadius = {
  regular: 2,
};

const typography = {
  fontFamily:
    'Public Sans, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Arial, sans-serif',
  fontWeight: {
    light: 300,
    regular: 400,
    semibold: 600,
    bold: 700,
  },
};

const shape = {
  borderRadius: {
    sm: spacing['xxxsmall'],
    md: spacing['xxsmall'],
  },
};

const gradient = {
  0: 'none',
  regular: 'linear-gradient(116.68deg, rgba(41, 41, 41, 0.5) -4.44%, rgba(20, 21, 22, 0.5))',
  gold: 'linear-gradient(45deg, rgba(241, 192, 134, 0.64), rgba(199, 145, 100, 0.64)) 1',
};

export const theme = {
  palette,
  shadows,
  typography,
  shape,
  gradient,
  bordedRadius,
};
